/**
 * Dashboard view logic (§ G35).
 *
 * The dashboard no longer lists itineraries you are only HOLDING for somebody
 * else — an organizer who adds eight attendees was getting eight cards of other
 * people's travel in front of their own two trips (Wade, 2026-08-17: *"When I go
 * to my TripMuscle dashboard I see all trips for Meetings. Since I'm a system
 * user I should not, only my trips."*).
 *
 * Hiding them silently would be its own bug — the organizer built those
 * itineraries and has to be able to find them. So the dashboard SAYS what it
 * withheld and points at the meetings page, which is where the roster already
 * links every attendee's trip.
 */
export function heldForMeetingsNote(count: number | null | undefined): string | null {
  // `Number(null) === 0` has bitten this codebase three times in one day; be
  // explicit rather than truthy-testing a number.
  const n = typeof count === 'number' && Number.isFinite(count) ? Math.trunc(count) : 0;
  if (n <= 0) return null;
  if (n === 1) {
    return 'One more itinerary is yours to manage but not yours to travel — it belongs to a meeting.';
  }
  return `${n} more itineraries are yours to manage but not yours to travel — they belong to meetings.`;
}
